// extracted by mini-css-extract-plugin
module.exports = {"h3Class":"H3_h3Class__2nZUI"};